import * as React from "react";
import Moment from 'react-moment';

//https://stackoverflow.com/questions/1500260/detect-urls-in-text-with-javascript
function createTextLinks(text) {
    let regexpText = "((?:(http|https|Http|Https|rtsp|Rtsp):\\/\\/(?:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)"
+ "\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,64}(?:\\:(?:[a-zA-Z0-9\\$\\-\\_"
+ "\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,25})?\\@)?)?"
+ "((?:(?:[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}\\.)+"   // named host
+ "(?:"   // plus top level domain
+ "(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])"
+ "|(?:biz|b[abdefghijmnorstvwyz])"
+ "|(?:cat|com|coop|c[acdfghiklmnoruvxyz])"
+ "|d[ejkmoz]"
+ "|(?:edu|e[cegrstu])"
+ "|f[ijkmor]"
+ "|(?:gov|g[abdefghilmnpqrstuwy])"
+ "|h[kmnrtu]"
+ "|(?:info|int|i[delmnoqrst])"
+ "|(?:jobs|j[emop])"
+ "|k[eghimnrwyz]"
+ "|l[abcikrstuvy]"
+ "|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])"
+ "|(?:name|net|n[acefgilopruz])"
+ "|(?:org|om)"
+ "|(?:pro|p[aefghklmnrstwy])"
+ "|qa"
+ "|r[eouw]"
+ "|s[abcdeghijklmnortuvyz]"
+ "|(?:tel|travel|t[cdfghjklmnoprtvwz])"
+ "|u[agkmsyz]"
+ "|v[aceginu]"
+ "|w[fs]"
+ "|y[etu]"
+ "|z[amw]))"
+ "|(?:(?:25[0-5]|2[0-4]" // or ip address
+ "[0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\\.(?:25[0-5]|2[0-4][0-9]"
+ "|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1]"
+ "[0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}"
+ "|[1-9][0-9]|[0-9])))"
+ "(?:\\:\\d{1,5})?)" // plus option port number
+ "(\\/(?:(?:[a-zA-Z0-9\\;\\/\\?\\:\\@\\&\\=\\#\\~"  // plus option query params
+ "\\-\\.\\+\\!\\*\\'\\(\\)\\,\\_])|(?:\\%[a-fA-F0-9]{2}))*)?"
        + "(?:\\b|$)";
    let regexp = new RegExp(regexpText,'gi');
    return (text || "").replace(
        regexp,
        function(match) {
            var hyperlink = match;
            if (!match.match('^https?://')) {
                hyperlink = 'http://' + hyperlink;
            }
            return '<a target="_blank" href="' + hyperlink + '">' + match + '</a>';
        }
    );
};

class Messages extends React.Component <any,any> {
    messagesEnd:any
    messagesList:any
    searchInput:any
    clearButton:any
    constructor(props) {
        super(props);
        this.state = {
            filterMessages:false,
            searchText:"",
            lastFilteredMessage:null,
        };
    }
    filterMessages() {
        let lastFilteredMessage;
        let messageCount = this.props.messages.length;
        if(messageCount) {
            lastFilteredMessage = this.props.messages[messageCount - 1];
        } else {
            lastFilteredMessage = null;
        }
        this.setState({
            filterMessages:true,
            lastFilteredMessage:lastFilteredMessage,
            searchText: this.searchInput.value,
        });
        if(this.searchInput.value) {
            this.clearButton.style.visibility = 'visible';
        } else {
            this.clearButton.style.visibility = 'hidden';
        }
    }
    search() {
        this.filterMessages();
    }
    onSubmit(e) {
        this.filterMessages();
        e.preventDefault();
    }
    clear() {
        this.searchInput.value = "";
        this.setState({filterMessages:false,searchText:""});
        this.clearButton.style.visibility = 'hidden';
    }
    render() {
        const {messages} = this.props;
        return (
            <React.Fragment>
                <div className="search-form-container">
                    <form className="search-form" onSubmit={e => {this.onSubmit(e)}}>
                        <span className="search-input-wrapper">
                            <input placeholder="Search in messages" className="search-input" type="text" ref={(el) => {this.searchInput=el; }} />
                            <span ref={(el) => {this.clearButton = el;}}  onClick={e => {this.clear()}} className="clear">&times;</span>
                        </span>
                        <input className="search-button" type="button" value="Search" onClick={() => this.search()}/>
                    </form>
                </div>
                <div className="search-info" >{(this.state.filterMessages && this.state.searchText !== "") ? "Search text: " + this.state.searchText : ""}</div>
                <ul ref={(el) => { this.messagesList = el;}}  className="messages">
                    {messages.map(m => this.renderMessage(m))}
                    <div ref={(el) => { this.messagesEnd = el;}}/>
                </ul>
            </React.Fragment>
        );
    }
    deleteMessage(messageId) {
        this.props.deleteMessage(messageId);
    }
    componentDidUpdate() {
        this.messagesList.scrollTop = this.messagesEnd.offsetTop;
    }
    componentDidMount() {
        // componentDidUpdate doesn't fire in the release version of the app
        setTimeout(() => {
            this.messagesList.scrollTop = this.messagesEnd.offsetTop;
        },200);
    }
    renderMessage(message) {
        const {id,text, senderId, createdAt} = message;
        const {currentUser} = this.props;
        const messageFromMe = currentUser.id === message.senderId;
        const className = messageFromMe ? "message currentMember" : "message";

        if(this.state.filterMessages
           && this.state.searchText
           && this.state.lastFilteredMessage
           && createdAt <= this.state.lastFilteredMessage.createdAt
        ) {
            if(text.toLowerCase().search(this.state.searchText.toLowerCase()) === -1) {
                return;
           }
        }

        const textWithLinks = createTextLinks(text);

        let username;
        let avatar;
        let deleteMessageButton;
        if(messageFromMe) {
            deleteMessageButton = <div><a onClick={(e)=> this.deleteMessage(id)} className="deleteMessage" href="#">Delete</a></div>;
            if(currentUser.name) {
                username = currentUser.name;
            } else {
                username = currentUser.email;
            }
            if (currentUser.image_src) {
                avatar = <img alt="" className="avatar" src={currentUser.image_src} />;
            } else {
                avatar = <span className="placeholder" style={{backgroundColor: "red"}} />;
            }
        } else {
            const user = this.props.users[senderId];
            if(user) {
                if(user.name) {
                    username = user.name;
                } else {
                    username = user.email;
                }
                if (user.image_src) {
                    avatar = <img alt="" className="avatar" src={user.image_src} />;
                } else {
                    avatar = <span className="placeholder" style={{backgroundColor: "blue"}} />;
                }
            }
        }
        return (
            <li className={className} key={id}>
                {avatar}
                <div className="messageContent">
                    <div className="username">
                        {username}
                    </div>
                    <div className="text">
                        <div dangerouslySetInnerHTML={{__html:textWithLinks}}/>
                        <div>{deleteMessageButton}</div>
                    </div>
                    <div>
                        <Moment format="HH:mm:ss DD/MM/YYYY">
                            {createdAt}
                        </Moment>
                    </div>
                </div>
            </li>
        );
    }
}

export default Messages;
